import { Component, Prop, Vue} from "vue-property-decorator";
import {  Product } from "../models";

@Component
export default class ProductSpecification extends Vue {
    @Prop()
    protected product!: Product;
}
